var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "head_box flex_start flex_center_align" }, [
        _c("img", {
          attrs: { src: require("@/assets/images/r2.png"), alt: "" },
        }),
        _c(
          "span",
          { staticClass: "hd_title" },
          [
            _vm._t("hd_title", function () {
              return [_vm._v("報告書一覧")]
            }),
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "filelist_box" }, [
        _c(
          "span",
          { staticClass: "f_title" },
          [
            _vm._t("f_title", function () {
              return [_vm._v("報告書の提出を行ってください")]
            }),
          ],
          2
        ),
      ]),
      _vm._l(_vm.fileList, function (row, index) {
        return _c("div", { key: index, staticClass: "file_box_new" }, [
          _c(
            "div",
            { staticClass: "header_box flex_start flex_center_align" },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(" " + _vm._s(row.docName) + " "),
              ]),
              !row.btnDisabled && !_vm.view
                ? _c("vab-upload", {
                    attrs: {
                      "batch-url": row.uploadAllUrl,
                      disabled: _vm.disabledMoreUpload(row.list[0].fileList),
                      "params-data": row,
                      multiple: true,
                      "btn-name": _vm.btnName,
                      "su-ts": false,
                    },
                    on: {
                      "on-change": _vm.uploadChange,
                      "on-success-bath": function (res) {
                        return _vm.successFileBath(res, row)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.disabledMoreUpload(row.list[0].fileList)
            ? _c(
                "div",
                {
                  staticClass: "file_item_box",
                  class: { flex_space: row.list && row.list.length > 1 },
                },
                [
                  _c(
                    "div",
                    { staticClass: "border_ae1" },
                    [
                      row.requiredFlg == 2 && row.prestatusName
                        ? _c("div", { staticClass: "state_box_off" }, [
                            _c("div", { staticClass: "col_content_cont" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "flex_start box_st",
                                  class: {
                                    changeBox: _vm.isEqualCodeEnum(
                                      row.preReportStatus,
                                      _vm.$divisions.reportStatusEnum.enum_04
                                    ),
                                  },
                                },
                                [
                                  _c("svg-icon", {
                                    attrs: {
                                      "icon-class": _vm.isEqualCodeEnum(
                                        row.officalReportStatus,
                                        _vm.$divisions.reportStatusEnum.enum_04
                                      )
                                        ? "cha"
                                        : "dui",
                                    },
                                  }),
                                  _c("span", { staticClass: "mark" }, [
                                    _vm._v(_vm._s(row.prestatusName)),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      row.requiredFlg == 1 && row.offstatusName
                        ? _c("div", { staticClass: "state_box_off" }, [
                            _c("div", { staticClass: "col_content_cont" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "flex_start box_st",
                                  class: {
                                    changeBox: _vm.isEqualCodeEnum(
                                      row.officalReportStatus,
                                      _vm.$divisions.reportStatusEnum.enum_04
                                    ),
                                  },
                                },
                                [
                                  _c("svg-icon", {
                                    attrs: {
                                      "icon-class": _vm.isEqualCodeEnum(
                                        row.officalReportStatus,
                                        _vm.$divisions.reportStatusEnum.enum_04
                                      )
                                        ? "cha"
                                        : "dui",
                                    },
                                  }),
                                  _c("span", { staticClass: "mark" }, [
                                    _vm._v(_vm._s(row.offstatusName)),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._l(row.list, function (item, cIndex) {
                        return _c(
                          "div",
                          {
                            key: cIndex,
                            staticClass: "file_item",
                            class: { more_colum: row.list.length > 1 },
                          },
                          [
                            _vm.changeFileList(item.fileList).length
                              ? _c(
                                  "div",
                                  { staticClass: "pdtb4 flex_colum" },
                                  [
                                    _vm._l(item.fileList, function (file, f) {
                                      return _c(
                                        "div",
                                        {
                                          key: f,
                                          staticClass:
                                            "file_inner_item flex_start psr",
                                        },
                                        [
                                          file.operationType !=
                                          _vm.$divisions.operationTypeEnum
                                            .enum_D.value
                                            ? [
                                                _c("svg-icon", {
                                                  staticClass: "arrow",
                                                  attrs: {
                                                    "icon-class":
                                                      "tryangle_right",
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex_colum file_name_box",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "file_name",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.downLoad(
                                                              row,
                                                              file
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              file.fileName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "file_time",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " アップロード日時：" +
                                                            _vm._s(
                                                              file.createDate
                                                            ) +
                                                            "  " +
                                                            _vm._s(
                                                              file.createTime.substring(
                                                                0,
                                                                8
                                                              )
                                                            ) +
                                                            "  |  " +
                                                            _vm._s(
                                                              _vm.getEnumText(
                                                                file.submitSourceClass,
                                                                _vm.$divisions
                                                                  .adjSourceClassEnum
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm.deleteShow(row, file)
                                                      ? _c("svg-icon", {
                                                          staticClass: "del",
                                                          attrs: {
                                                            "icon-class":
                                                              "close_circle_fill",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deleteFile(
                                                                row,
                                                                file,
                                                                item,
                                                                f
                                                              )
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "header_box file_item_btn_box pos_right",
                                                  },
                                                  [
                                                    !row.btnDisabled &&
                                                    !_vm.view
                                                      ? _c("vab-upload", {
                                                          attrs: {
                                                            "upload-url":
                                                              row.uploadUrl,
                                                            "params-data":
                                                              Object.assign(
                                                                {},
                                                                row,
                                                                {
                                                                  fileId:
                                                                    file.fileId,
                                                                }
                                                              ),
                                                            multiple: false,
                                                            "su-ts": false,
                                                            "btn-name":
                                                              file.btnName,
                                                          },
                                                          on: {
                                                            "on-success":
                                                              function (res) {
                                                                return _vm.rowSuccessFile(
                                                                  res,
                                                                  row,
                                                                  file,
                                                                  f
                                                                )
                                                              },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "header_box file_item_btn_box file_bottom_btn",
                                      },
                                      [
                                        !row.btnDisabled && !_vm.view
                                          ? _c("vab-upload", {
                                              attrs: {
                                                "upload-url": row.uploadUrl,
                                                "params-data": row,
                                                multiple: false,
                                                "su-ts": false,
                                                "btn-name": item.btnName,
                                              },
                                              on: {
                                                "on-success": function (res) {
                                                  return _vm.successFile(
                                                    res,
                                                    row
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }